export default __webpack_public_path__ + "static/media/smooth_rock.c4c0c371.png";